const PARTENAIRE_TYPES = [
  { value: "clinique", label: "Clinique" },
  { value: "laboratoire", label: "Laboratoire" },
  { value: "pharmacy", label: "Pharmacie" },
  { value: "clinique_laboratoire", label: "Clinique et Laboratoire" },
];
const PRESCRIPTION_MEDECIN_CONESEIL_AVIS = {
  valider: "valider",
  rejeter: "rejeter",
  en_attente: "en_attente",
};
export { PARTENAIRE_TYPES, PRESCRIPTION_MEDECIN_CONESEIL_AVIS };
